/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import Container from '@mui/material/Container';
import { Chart as ChartJS, RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend } from 'chart.js';
import { Radar } from 'react-chartjs-2';
import { useRecoilValue } from 'recoil';
import { projectsDataAtom } from '../Atoms/index';

ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

const useStyles = makeStyles({
  radar: {
    width: '18vw',
    height: '18vh',
    minWidth: '290px',
    minHeight: '135px',
  },
});

export default function RadarChart({ projectName }) {
  const classes = useStyles();
  const projectsData = useRecoilValue(projectsDataAtom);
  const [currentProjectData, setCurrentProjectData] = useState([]);

  useEffect(() => {
    setCurrentProjectData(projectsData.find((x) => x.Name === projectName && x.isCurrent === 1));
  }, [projectsData]);

  const data = {
    labels: ['FIN-ECO', 'PRD-LOG', 'TEC-IND', 'DOC-QUA', 'HR-COMM'],
    datasets: [
      {
        label: 'INT',
        data: [
          currentProjectData?.iFINECO,
          currentProjectData?.iPRDLOG,
          currentProjectData?.iTECIND,
          currentProjectData?.iDOCQUA,
          currentProjectData?.iHRCOMM,
        ],
        fill: true,
        backgroundColor: 'rgba(144,236,217, 0.2)',
        borderColor: 'rgb(144,236,217)',
        pointBackgroundColor: 'rgb(144,236,217)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgb(144,236,217)',
      },
      {
        label: 'EXT',
        data: [
          currentProjectData?.eFINECO,
          currentProjectData?.ePRDLOG,
          currentProjectData?.eTECIND,
          currentProjectData?.eDOCQUA,
          currentProjectData?.eHRCOMM,
        ],
        fill: true,
        backgroundColor: 'rgba(54, 162, 235, 0.2)',
        borderColor: 'rgb(54, 162, 235)',
        pointBackgroundColor: 'rgb(54, 162, 235)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: 'rgb(54, 162, 235)',
      },
    ],
  };

  return (
    <Container className={classes.radar}>
      <Radar data={data} />
    </Container>
  );
}
